import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../BaseUrl";

export const getVerifyPurReq = createAsyncThunk(
    "/admin/getVerifyPurReq",
    async ({ payload }) => {
        try {
            const myurl = `${V_URL}/admin/pro-list-admin-pr`;
            const response = await axios({
                method: "post",
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });
            const data = response.data;
            // console.log(data, "adminGetEmployee response");
            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error;
        }
    }
);

const getVerifyPurReqSlice = createSlice({
    name: "getVerifyPurReq",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getVerifyPurReq.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getVerifyPurReq.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getVerifyPurReq.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default getVerifyPurReqSlice.reducer;
